module.exports = __webpack_public_path__ + "img/nav-thumbnail-mario-galaxy.a05eb3fd.png";